export default "__VITE_ASSET__CeikTZTq__";